<template>
    <div class="send" :style="{minHeight:minHeight+'px'}" @click="hidedraft()">
        <!-- <router-view/> -->
        <headerCom></headerCom>
        <div class="send-content bg-white text-df" :style="{minHeight:minHeight+'px'}" >
            <draftcover ref="collectcover" v-on:getdraftid="getdraftid"></draftcover>
            <div class="padding" v-if="draftinfo">
                <div class="solids radius padding">
                    <div class="text-xxl">
                      <el-input
                        placeholder="为 结果查询 命名" maxlength="50"
                        suffix-icon="el-icon-edit" @change="updateResultQueryName"
                        v-model="resultQueryName">
                      </el-input>
                      </div>
                    <div class="margin-top">一个活动建议将不同组别的获奖统一在一个文档里面，无需使用多个文档提供结果来查询</div>
                    <div class=" flex justify-end">
                        <div class="bg-gradual-green padding-lr-xl padding-tb-sm round cursor" @click="updateStatus">
                            {{draftinfo.activityAuth.isResultQuery==1?'已':''}}启用
                        </div>
                    </div>
                </div>
                <div :class="draftinfo.activityAuth.isResultQuery==1?'':'disabled'" class="margin-top">
                    <router-link to="/home/resultQuery/update" tag="div">
                        <el-button type="success" round>╋ 新建</el-button>
                    </router-link>
                    <el-table class="margin-top"
                              :data="tableData"
                              style="width: 100%">
                        <el-table-column
                                prop="name"
                                label="查询文档名称">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="生成时间"
                                width="180">
                            <template slot-scope="scope">
                                <div>{{unixtoTime(scope.row.createTime,"YYYY/MM/DD HH:II")}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="180">
                            <template slot-scope="scope">
                                <el-button round
                                           size="mini"
                                        type="danger"
                                        @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                                <el-button round type="success"
                                           size="mini"
                                        @click="invite(scope.row)">邀请</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </div>
        </div>
        <el-dialog v-if="draftinfo"
                :title="'分享'+(shareItem.title||'')"
                :visible.sync="dialogVisible"
                width="50%" append-to-body
                :before-close="handleClose" class="fotoo">
            <div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="微信分享(二维码)" name="wechat">
                        <div class="block" style="text-align: center;padding-top: 40px;">
                            <el-image :src="codeurl">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                            </el-image>
                            <div style="margin-top: 20px;">
                                <el-button type="success" round @click="downcode" style="width: 200px;">保存</el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="关联公众号" name="link">
                        <div class="block text-black text-xl text-500">
                            <div class="">公众号菜单/文章，请使用以下信息添加</div>
                            <div class="flex align-center justify-between margin-top-sm">
                                <div>APPID：{{shareItem.appid}}</div>
                                <el-button type="success" round @click="copy('appid')">复制</el-button>
                            </div>
                            <div class="link-tips margin-top-xxl">页面路径：</div>
                            <div class="flex align-center justify-between margin-top-sm">
                                <div>{{shareItem.path}}</div>
                                <el-button type="success" round @click="copy('path')">复制</el-button>
                            </div>
                        </div>
                    </el-tab-pane>

                </el-tabs>
            </div>
        </el-dialog>
    </div>

</template>

<script>
  import headerCom from '../../components/header.vue'
  import draftcover from '../../components/draftcover.vue'
  import App from '../../util/comfun'
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
  export default {
    //name: 'resultQuery',
    data() {
      return {
        draftinfo:null,
        minHeight: window.innerHeight - 82,
        tableData: [],
        dialogVisible:false,
        activeName: 'wechat',
        codeurl:'',
        shareItem:{},
        resultQueryName: '结果查询',
      }
    },
    components: {
      ElButton,
      headerCom,
      draftcover,
    },
    methods: {
      unixtoTime:App.unixtoTime,
      getdetail() {
        App.Contribution.GetContributionById({
          activityId:this.activityId,
        }).then(res=>{
          this.draftinfo=res.data
          this.resultQueryName = this.draftinfo.activityAuth.resultQueryName || '结果查询';
        })
      },
      getdraftid(obj) {
        console.log('getdraftid',obj)
        this.activityId = obj.id;
        this.hidedraft();
        this.getdetail();
        this.getList()
      },
      hidedraft() {
        if(this.$refs.collectcover){
          this.$refs.collectcover.closedraft();
        }
      },
      updateResultQueryName(){
          if(!this.resultQueryName){
            this.$message.error('请输入结果查询名称')
            return
          }
          if(this.draftinfo.activityAuth.resultQueryName==this.resultQueryName) return
          this.updateStatus(false)
      },
      updateStatus(hasStatus){
        console.log('updateStatus',hasStatus)
        if(this.draftinfo.activityAuth.openResultQuery!=1){
          return this.$router.push({path: '/checkout/buyVip?activityId='+this.draftinfo.activityId+'&activityName='+this.draftinfo.activityName})
        }
        this.loading = this.$loading({text: '处理中...', target: '.el-drawer'})
        let enable = this.draftinfo.activityAuth.isResultQuery
        if(hasStatus){
          enable = this.draftinfo.activityAuth.isResultQuery!=1?1:0
        }
        App.demand('/activity/auth/setResultQuery','GET',{
          activityId:this.activityId,
          enable:enable,
          resultQueryName:this.resultQueryName||'结果查询',
        }).then(res=>{
          this.getdetail();
          this.loading.close()
        })
      },
      handleClose(done) {
        done();
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      //邀请投稿
      async invite(item) {
        console.log(item)
        let param={
          gotopath:'/poster/resultQuery/query',
          activityId:this.activityId||item.activityId,
          resId:item.id,
        }
        item.path=App.http_build_query(param,'/pages/enter/enter')
        item.appid='wx397090124c858e7c'
        this.shareItem=item
        this.dialogVisible=true
        let res = await App.demand('/activity/wechatapplet/saveParam', 'GET', {
          param: JSON.stringify(param)
        });
        App.System.Qrcode({
          autoColor:false,
          inHyaline:false,
          lineColor:'0,0,0',
          page:'pages/enter/enter',
          scene:res.data,
          width:300
        },'URL').then(codeurl=>{
          this.codeurl=codeurl
        })
      },
      copy(key){
        let createInput = document.createElement("input");
        createInput.value = this.shareItem[key];
        document.body.appendChild(createInput);
        createInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        createInput.style.display = "none";
        this.$message({ message: "复制成功", type: "success" });
      },
      downcode(){
        App.download(this.codeurl,this.shareItem.name)
      },

      handleDelete(index,row) {
        console.log(arguments)
        this.$confirm(row.name+'将被删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          App.demand('/activity/resultQuery/delete','GET',{
            id:row.id,
          }).then(res=>{
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
        }).catch(() => {

        });
      },
      getList(){
        if(!this.activityId) return
        App.demand('/activity/resultQuery/loadQueryList','GET',{
          activityId:this.activityId,
        }).then(res=>{
          this.tableData=res.data.list||[]
        })
      },
    },
    mounted() {
      //console.error('window.newData',window.newData)
      this.getList()
      if(window.newData){
        this.invite(window.newData)
        delete window.newData
      }
    },

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/resultQuery/index.vue